module.exports = __webpack_public_path__ + "58739fc371b207219f680675a3c63e48.svg";